/*
 * @Author: cmchiu
 * @Date: 2023-04-06 15:01:41
 * @LastEditTime: 2023-04-06 15:19:44
 * @LastEditors: cmchiu
 * @Description:
 * @FilePath: \IACMP\IACMP_Client\src\store\modules\permission.js
 *
 */
import { asyncRoutes, constantRoutes } from '@/router/routes.js'
import { getMenu } from '@/api/common'
import { loadMenu } from '@/utils/menu'
import Layout from '@/layout'

/**
 * 靜態路由懶載入
 * @param view  格式必須為 xxx/xxx 開頭不要加斜杠
 * @returns
 */
export const loadView = view => {
    return resolve => require([`@/views/${view}.vue`], resolve)
}

/**
 * 把從後端查詢的選單數據拼裝成路由格式的數據
 * @param routes
 * @param data 後端返回的選單數據
 */
export function generaMenu(routes, data) {
    data.forEach(item => {
        const menu = {
            path: item.url,
            component: item.component === '#' ? Layout : loadView(item.component),
            hidden: item.status === 0, // 狀態為0的隱藏
            redirect: item.redirect,
            children: [],
            name: item.code,
            meta: item.meta,
        }

        if (item.children) {
            generaMenu(menu.children, item.children)
        }
        routes.push(menu)
    })
    return routes
}

const state = {
    routes: [],
    addRoutes: [],
}

const mutations = {
    SET_ROUTES: (state, routes) => {
        state.addRoutes = routes
        // 拼接靜態路由和動態路由
        state.routes = constantRoutes.concat(routes)
    },
}

const actions = {
    generateRoutes({ commit }) {
        return new Promise(resolve => {
            // 通過token從後端獲取用戶選單，並加入全局狀態
            getMenu()
                .then(res => {
                    // 將選單資料轉成路由格式的數據
                    const menuData = loadMenu(res.Items)
                    const tempAsyncRoutes = Object.assign([], asyncRoutes)
                    // const accessedRoutes = generaMenu(tempAsyncRoutes, menuData);
                    const accessedRoutes = tempAsyncRoutes.concat(menuData)

                    commit('SET_ROUTES', accessedRoutes)
                    resolve(accessedRoutes)
                })
                .catch(error => {
                    console.log(error)
                })
        })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
